import {Alert} from "react-bootstrap";
import {CartStateRequestType, CartStateType} from "../../redux/slices/carts";
import * as React from "react";
import {OffCanvasProductModel} from "./offCanvasProductModel";

export class AddToCartItemDetailsModel {
    private _product: OffCanvasProductModel;
    private _cart: CartStateType;
    private _request: CartStateRequestType | undefined;

    constructor(product: OffCanvasProductModel, cart: CartStateType) {
        this._product = product;
        this._cart = cart;
        this._request = cart.request;
    }

    public get artworkGuidelineTypeID(): number {
        return this._product?.artworkGuidelineTypeId ?? 0;
    }

    public get artworkLeadTime(): number {
        return this._product.stockInformation?.artworkLeadTime ?? 0;
    }

    public get artworkName(): string | null | undefined {
        return this._request?.artworkName;
    }

    public get artworkNotes(): string | null | undefined {
        return this._request?.artworkNotes;
    }

    public get backOrderQuantity(): number | undefined {
        if (!this.quantity) return undefined;
        return this.quantity - this.quantityOnHand;
    }

    public get isInStock(): boolean {
        return this._product.stockInformation?.isInStock ?? false;
    }

    public get leadOut(): number {
        return this._product.stockInformation?.leadOut ?? 0;
    }

    public get leadIn(): number {
        return this._product.stockInformation?.leadIn ?? 0;
    }

    public get quantity(): number | undefined {
        return this._cart.cartItemQuantity;
    }

    public get isInTransit() {
        return this._product.stockInformation?.isInTransit ?? false;
    }

    public get inTransitDays() {
        return this._product.stockInformation?.inTransitDays ?? 0;
    }

    public get quantityOnHand(): number {
        return this._product.stockInformation?.quantityOnHand ?? 0;
    }

    public get backOrderMessage() {
        const backOrderQuantity = this.backOrderQuantity ?? 0;
        if (backOrderQuantity > 0 && this.quantityOnHand === 0) {
            const leadOut = this.isInTransit ? this.inTransitDays : this.leadOut;
            return <Alert variant="danger" className="mb-0 mt-3 py-2 ">This item is backordered and
                will ship in approximately {leadOut} day{leadOut > 1 ? "s" : ""}</Alert>;
        } else if (backOrderQuantity > 0 && this.quantityOnHand > 0) {
            return <Alert variant="warning" className="mb-0 mt-3 py-2 ">{backOrderQuantity} of
                the {this.quantity} items are currently backordered. During checkout you may choose to ship the partial
                order or wait to ship the entire order in full.</Alert>
        } else if (backOrderQuantity > 0 && this.quantityOnHand <= 0) {
            return <Alert variant="danger" className="mb-0 mt-3 py-2 ">Backordered</Alert>
        } else if (this.isInStock && this.leadIn > 0) {
            return <Alert variant="info" className="mb-0 mt-3 py-2 ">This item will
                ship {(this.artworkGuidelineTypeID != 0 && this.artworkGuidelineTypeID != 6 ? "" : "in")} approximately {this.leadIn} business
                day{(this.leadIn > 1 ? "s" : "")}{(this.artworkGuidelineTypeID != 0 && this.artworkGuidelineTypeID != 6 ? ` after artwork has been approved. Once submitted, please allow ${this.artworkLeadTime} business days for artwork review.` : ".")}
            </Alert>
        } else {
            return null;
        }
    }

    public get artworkNotesMessage() {
        return (
            this.artworkNotes && this.artworkNotes.trim() !== "" ?
                `${(this.artworkGuidelineTypeID == 6 ? "Your Text:" : "Instructions:")}` :
                undefined
        );
    }
}